/* eslint-disable no-undef */
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { resolveTenant } from "./utils/customDomains";

const getSubdomain = () => {
  // Get the full hostname
  const hostname = globalThis.location.hostname; // e.g., "subdomain.example.com"
  if (
    hostname === "192.168.1.31" ||
    hostname === "192.168.1.159" ||
    hostname === "localhost"
  ) {
    return "dev-upgraded";
  }
  // Client-owned masked domains (e.g. mentoring.sid.org.sg) map to a tenant
  // explicitly — subdomain parsing below would yield a wrong value for them.
  const customTenant = resolveTenant(hostname);
  if (customTenant) {
    return customTenant;
  }
  // Split the hostname into parts
  const parts = hostname.split(".");

  // Check if there's a subdomain
  if (parts.length > 2) {
    // Return the subdomain
    return parts.slice(0, -2).join("."); // Join parts back to a string
  } else {
    alert("Please check the domain and try again");
    globalThis.location.href = "https://www.vlookup.ai";
  }
};

const getDomainSpecificDatabase = () => {
  switch (getSubdomain()) {
    case "dev":
      return process.env.REACT_APP_DEV_DATABASE_URL;
    case "essecdev":
      return process.env.REACT_APP_ESSEC_DEV_DATABASE_URL;
    case "simdev":
      return process.env.REACT_APP_SIM_DEV_DATABASE_URL;

    case "siddev":
      return process.env.REACT_APP_SIDDEV_DATABASE_URL;
    case "siduat":
      return process.env.REACT_APP_SIDUAT_DATABASE_URL;
    case "sid":
      return process.env.REACT_APP_SID_DATABASE_URL;
    case "uat":
      return process.env.REACT_APP_UAT_DATABASE_URL;
    case "essecuat":
      return process.env.REACT_APP_ESSEC_UAT_DATABASE_URL;
    case "simuat":
      return process.env.REACT_APP_SIM_UAT_DATABASE_URL;

    case "sim":
      return process.env.REACT_APP_SIM_DATABASE_URL;
    case "essec":
      return process.env.REACT_APP_ESSEC_DATABASE_URL;

    default:
      return process.env.REACT_APP_DEFAULT_DATABASE_URL;
  }
};

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: getDomainSpecificDatabase(),
  // "https://vlookup-f5ebb-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebase = initializeApp(config);

export const database = getDatabase(firebase);
export default firebase;
